import { render } from "./Mail.vue?vue&type=template&id=a1cf3f4a"
const script = {}

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__